import { render, staticRenderFns } from "./CreateNewBookYearCard.vue?vue&type=template&id=f70ba23e"
import script from "./CreateNewBookYearCard.vue?vue&type=script&lang=ts"
export * from "./CreateNewBookYearCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f70ba23e')) {
      api.createRecord('f70ba23e', component.options)
    } else {
      api.reload('f70ba23e', component.options)
    }
    module.hot.accept("./CreateNewBookYearCard.vue?vue&type=template&id=f70ba23e", function () {
      api.rerender('f70ba23e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bookyear/CreateNewBookYearCard.vue"
export default component.exports